import React, { useEffect, useState } from 'react';
import i18n from '@nextroll/ar-i18n';
import classNames from 'classnames';

interface ISaveButtonProps {
    label?: string; // override the label text
    loading: boolean;
    disabled: boolean;
    onClick?: () => void;
}

// Linked to $save-revert-timeout-duration SCSS variable
export const TIMEOUT_DURATION = 2500;

export const SaveButton = ({ label, loading, disabled, onClick }: ISaveButtonProps) => {
    const [savingState, setSavingState] = useState('save' as 'save' | 'saving' | 'saved');
    // Prevents transition on initial page load
    const [fadeIn, setFadeIn] = useState(false);

    // Handle Save -> Saving -> Saved -> Save
    useEffect(() => {
        let savedTimer: NodeJS.Timeout;

        if (loading) {
            setSavingState('saving');
        }
        if (savingState === 'saving' && !loading) {
            setSavingState('saved');
            setFadeIn(true);
        }
        if (savingState === 'saved') {
            savedTimer = setTimeout(() => {
                setSavingState('save');
            }, TIMEOUT_DURATION);
        }
        return () => {
            clearTimeout(savedTimer);
        };
    }, [loading, savingState]);

    const disableButton = loading || savingState === 'saved' || disabled;

    const saveBtnClassnames = classNames('btn btn-default save-btn', savingState, {
        disable: disableButton,
    });

    return (
        <button
            className={saveBtnClassnames}
            onClick={disableButton ? undefined : onClick}
            type='button'
            role='button'
        >
            {savingState === 'save'
                && <span className={fadeIn ? 'fade-in' : ''}>{label || i18n.gettext('Save')}</span>}
            {savingState === 'saving'
                && (
                    <>
                        <i className='fas fa-circle-notch fast-spin' />
                        <span>{i18n.gettext('Saving')}</span>
                    </>
                )}
            {savingState === 'saved'
                && (
                    <div className='saved-contents'>
                        <i className='fas fa-check' />
                        <span>{i18n.gettext('Saved')}</span>
                    </div>
                )}
        </button>
    );
};
